__webpack_require__.p = "https://widget.dexkor.com/";